import React from 'react';
import Select from '../../components/Select/Select';
import styles from './stockReport.module.css';

const StockReportFilters = ({
  markOptions,
  modelOptions,
  cityOptions,
  dcOptions,
  selectedMarks,
  selectedModels,
  selectedCities,
  selectedDcs,
  onMarksChange,
  onModelsChange,
  onCitiesChange,
  onDcsChange,
  disabled,
}) => {
  return (
    <div className={styles.filters}>
      <div className={styles.filterItem}>
        <Select
          title="ÐÐ°ÑÐºÐ°"
          placeholder="ÐÑÐµ Ð¼Ð°ÑÐºÐ¸"
          options={markOptions}
          value={selectedMarks}
          isMulti
          isSearchable
          disabled={disabled}
          onChange={onMarksChange}
        />
      </div>
      <div className={styles.filterItem}>
        <Select
          title="ÐÐ¾Ð´ÐµÐ»Ñ"
          placeholder="ÐÑÐµ Ð¼Ð¾Ð´ÐµÐ»Ð¸"
          options={modelOptions}
          value={selectedModels}
          isMulti
          isSearchable
          disabled={disabled}
          onChange={onModelsChange}
        />
      </div>
      <div className={styles.filterItem}>
        <Select
          title="ÐÐ¾ÑÐ¾Ð´"
          placeholder="ÐÑÐµ Ð³Ð¾ÑÐ¾Ð´Ð°"
          options={cityOptions}
          value={selectedCities}
          isMulti
          isSearchable
          disabled={disabled}
          onChange={onCitiesChange}
        />
      </div>
      <div className={styles.filterItem}>
        <Select
          title="ÐÐ¸Ð»ÐµÑÑÐºÐ¸Ð¹ ÑÐµÐ½ÑÑ"
          placeholder="ÐÑÐµ ÐÐ¦"
          options={dcOptions}
          value={selectedDcs}
          isMulti
          isSearchable
          disabled={disabled}
          onChange={onDcsChange}
        />
      </div>
    </div>
  );
};

export default StockReportFilters;
